import { useCurrentTournamentAPIQuery } from '../services/queries';
import { useUserRegisteredTournaments } from './useUserRegisteredTournaments.ts';

export const useIsUserRegisteredForCurrentTournament = () => {
  const currentTournamentQuery = useCurrentTournamentAPIQuery();
  const userTournamentsQuery = useUserRegisteredTournaments();

  const isPending =
    currentTournamentQuery.isPending || userTournamentsQuery.isPending;
  const isError =
    currentTournamentQuery.isError || userTournamentsQuery.isError;
  const error = currentTournamentQuery.error || userTournamentsQuery.error;
  const isSuccess =
    currentTournamentQuery.isSuccess && userTournamentsQuery.isSuccess;

  const data =
    userTournamentsQuery.data &&
    currentTournamentQuery.data &&
    'id' in currentTournamentQuery.data &&
    userTournamentsQuery.data.data.tournaments.some(t => t.tournament_id === Number((currentTournamentQuery.data as { id: string }).id));

  return {
    isPending,
    isSuccess,
    isError,
    error,
    data,
  };
};
